import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page401',
  templateUrl: './page401.component.html',
  styleUrls: ['./page401.component.scss']
})
export class Page401Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
